import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import AppHeader from '@/components/layout/AppHeader';
import AppSidebar from '@/components/layout/AppSidebar';
import { useTenant } from '@/data/tenant';
import { useAuth, getTenantId } from '@/helpers/api';
import { useTheme } from '@/helpers/theme';
import Loader from '@/components/common/Loader';
import { useSelf } from '@/data/user';

const App = () => {
  useAuth();
  useTheme();
  const navigate = useNavigate();
  const tenant = useTenant();
  const user = useSelf();

  useEffect(() => {
    if (!getTenantId()) {
      navigate('/tenant');
    }
  }, [navigate]);

  if (tenant.isLoading && !tenant.data) {
    return (
      <div className="h-[100vh] flex items-center justify-center">
        <Loader />
      </div>
    );
  }

  if (user.isLoading && !user.data) {
    return (
      <div className="h-[100vh] flex items-center justify-center">
        <Loader />
      </div>
    );
  }

  return (
    <>
      <AppHeader />
      <div className="min-h-[calc(100vh-var(--header-height))]">
        <AppSidebar />
        <main className="pl-[280px] max-w-[1400px] mx-auto">
          <div className="p-4">
            <Outlet />
          </div>
        </main>
      </div>
    </>
  );
};

export default App;
